import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { DASHBOARD_MODES } from '@/components/Header/Header';

interface DashboardViewContextType {
  viewMode: string;
  setViewMode: (mode: string) => void;
}

const DashboardViewContext = createContext<DashboardViewContextType>({
  viewMode: DASHBOARD_MODES.STANDARD,
  setViewMode: () => {}
});

interface DashboardViewProviderProps {
  children: ReactNode;
}

export function DashboardViewProvider({ children }: DashboardViewProviderProps) {
  // Set initial value based on screen width
  const [viewMode, setViewMode] = useState(DASHBOARD_MODES.STANDARD);
  
  // Effect to check if mobile and set to executive dashboard
  useEffect(() => {
    const checkIfMobile = () => {
      // 768px is a common breakpoint for mobile devices
      const isMobile = window.innerWidth < 768;
      if (isMobile) {
        setViewMode(DASHBOARD_MODES.EXECUTIVE);
      }
    };
    
    // Check on initial load
    checkIfMobile();
    
    // No need to add a resize listener as we only want to set this initially
    // If we added a listener, the user's choice would be overridden when resizing
  }, []);

  const value = {
    viewMode,
    setViewMode
  };

  return (
    <DashboardViewContext.Provider value={value}>
      {children}
    </DashboardViewContext.Provider>
  );
}

export function useDashboardView() {
  const context = useContext(DashboardViewContext);
  if (context === undefined) {
    throw new Error('useDashboardView must be used within a DashboardViewProvider');
  }
  return context;
} 